module.exports = __webpack_public_path__ + "static/jamu-80e7ad74834a2dd6bf078b0151f6ac55.png";